import { render, staticRenderFns } from "./DebugDataDialog.vue?vue&type=template&id=ddbd26bc&scoped=true&lang=pug&"
import script from "./DebugDataDialog.vue?vue&type=script&lang=ts&"
export * from "./DebugDataDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DebugDataDialog.vue?vue&type=style&index=0&id=ddbd26bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddbd26bc",
  null
  
)

export default component.exports